import { PacketOut } from "./PacketOut.js";
import { OutboundPacketType } from "./OutboundPacketType.js";
import type { MessageIOContext } from "../../../api/MessageIOContext.js";
import type { GameMode } from "../../GameMode.js";
import type { Ruleset } from "../../Ruleset.js";


export class PacketOutJoinQueue extends PacketOut {
    private readonly queueMode: GameMode;
    private readonly queueType: Ruleset;

    constructor(queueMode: GameMode, queueType: Ruleset) {
        super(OutboundPacketType.JOIN_QUEUE);
        this.queueMode = queueMode;
        this.queueType = queueType;
    }

    override writeContents(_context: MessageIOContext): Record<string, any> {
        return {
            queue_game_mode: this.queueMode.getID(),
            queue_game_type: this.queueType.getID(),
        };
    }
}
